export const PREVIEW_UPLOAD_LAYOUT_ATTR = 'data-preview-upload-layout'

/** Legacy upload orientation marker; retained for render-mode compatibility. */
export const PREVIEW_UPLOAD_FIT_ATTR = 'data-preview-upload-fit'

export const PREVIEW_OUTPUT_LAYOUT_ATTR = 'data-preview-output-layout'

export const PREVIEW_CONTAIN_ATTR = 'data-preview-contain'

export const PREVIEW_COVER_ATTR = 'data-preview-cover'

function hasFitPreviewLayout(container: HTMLElement): boolean {
  return (
    container.hasAttribute(PREVIEW_UPLOAD_LAYOUT_ATTR)
    || container.hasAttribute(PREVIEW_OUTPUT_LAYOUT_ATTR)
    || container.hasAttribute(PREVIEW_CONTAIN_ATTR)
    || container.closest(`[${PREVIEW_UPLOAD_LAYOUT_ATTR}]`) !== null
    || container.closest(`[${PREVIEW_OUTPUT_LAYOUT_ATTR}]`) !== null
    || container.closest(`[${PREVIEW_CONTAIN_ATTR}]`) !== null
  )
}

function hasCoverPreviewLayout(container: HTMLElement): boolean {
  return (
    container.hasAttribute(PREVIEW_COVER_ATTR)
    || container.closest(`[${PREVIEW_COVER_ATTR}]`) !== null
  )
}

/** Apply true contain rendering for every uploaded-media aspect ratio. */
export function applyUploadPreviewMediaLayout(container: HTMLElement): void {
  if (hasCoverPreviewLayout(container)) {
    return
  }

  if (!hasFitPreviewLayout(container)) {
    return
  }

  container.style.overflow = 'hidden'
  container.style.display = 'flex'
  container.style.alignItems = 'center'
  container.style.justifyContent = 'center'

  container.querySelectorAll('div').forEach((node) => {
    if (node === container) {
      return
    }
    const el = node as HTMLElement
    el.style.width = '100%'
    el.style.height = '100%'
    el.style.display = 'flex'
    el.style.alignItems = 'center'
    el.style.justifyContent = 'center'
    el.style.overflow = 'hidden'
  })

  container.querySelectorAll('video, canvas').forEach((node) => {
    const el = node as HTMLElement
    el.style.display = 'block'
    el.style.objectFit = 'contain'
    el.style.objectPosition = 'center'
    el.style.position = 'relative'
    el.style.left = 'auto'
    el.style.right = 'auto'
    el.style.top = 'auto'
    el.style.bottom = 'auto'
    el.style.transform = 'none'
    el.style.width = '100%'
    el.style.height = '100%'
    el.style.maxWidth = 'none'
    el.style.maxHeight = 'none'
    el.style.margin = '0'
  })
}

export function observeUploadPreviewMediaLayout(container: HTMLElement): () => void {
  if (!hasFitPreviewLayout(container) && !hasCoverPreviewLayout(container)) {
    return () => {}
  }

  let rafId: number | null = null
  const apply = () => applyUploadPreviewMediaLayout(container)
  const scheduleApply = () => {
    if (rafId !== null) {
      return
    }
    rafId = requestAnimationFrame(() => {
      rafId = null
      apply()
    })
  }

  apply()
  const observer = new MutationObserver(() => scheduleApply())
  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
  })
  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId)
    }
    observer.disconnect()
  }
}
